export default __webpack_public_path__ + "45c02a0a710d33fa8c39b9584e7bc2d6.mp3";